<template>
  <page>
    <v-card>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 md6 xs12>
              <v-autocomplete
                :items="acctTypeList"
                :label="labels.riType"
                v-model="form.riType"
                item-text="label"
                item-value="value"
                data-vv-name="riType"
                :data-vv-as="labels.riType"
                :error-messages="errors.collect('riType')"
                v-validate="'required'">
              </v-autocomplete>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-text-field
                v-model="form.stmtRef"
                :label="labels.stmtRef"
                v-validate="'required'"
                data-vv-name="form.stmtRef"
                :data-vv-as="labels.stmtRef"
                :error-messages="errors.collect('form.stmtRef')"
                :hint="'EX: JAN2021,FEB2021'">
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-dialog v-model="showErrorDialog" width="800px" >
            <v-card>
              <v-toolbar dense color="grey lighten-3" flat>
                <v-icon>mdi-information</v-icon>
                <v-toolbar-title>System Information</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <div v-if="messages.length > 0" class="pb-3">
                <span class="info-dialog-msg-header">Oops something went wrong...</span>
                <v-spacer class="mt-2"></v-spacer>
                <ul class="showErrorMsgs">
                  <li v-for="(error, index) in messages" :key="index">
                  {{error.message}}
                  </li>
                </ul>
                </div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-container>
      </v-card-text>
      <v-btn color="error" dark class=" mr-2" @click.prevent="doCancel">Cancel<v-icon dark right>mdi-cancel</v-icon></v-btn>
      <v-btn color="primary" dark class=" mr-2" @click="doBatchRel" :loading="submitting">
        Post
        <v-icon right>mdi-file-send </v-icon>
      </v-btn>
    </v-card>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { acctType } from '@/const/params'
export default {
  data() {
    return {
      submitting: false,
      showErrorDialog: false,
      labels: {
        riType: 'Inwards / Outwards',
        stmtRef: 'Statement Ref'
      },
      form: {
        riType: 'O',
        stmtRef: undefined
      }
    }
  },
  watch: {
    'displayErrorDialog': {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('batchRelQrtlyTtyStmtInit')])
    },
    doBatchRel() {
      this.submitting = true
      this.$validator.validateAll().then(result => {
        if (result) {
          this.getBatchRelProcess()
        } else {
          this.promptFieldCheck()
          this.submitting = false
        }
      })
    },
    async getBatchRelProcess() {
      const apiURI = this.menu.getBatchRelQrtlyTtyStmtProcess
      if (apiURI) {
        try {
          const result = await this.$http.get(expandURI(apiURI, this.form))
          if (result) {
            this.$toast.success('Job successfully submitted to batch job process.')
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      this.submitting = false
    }
  },
  computed: {
    menu() {
      return this.$store.state.specFuncTtyAcct.batchRelQrtlyTtyStmt.menu
    },
    displayErrorDialog() {
      return this.messages
    },
    acctTypeList() {
      let result = []
      Object.keys(acctType).forEach(function (key) {
        const status = acctType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    MessageMixin
  ]
}
</script>
